"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESendingReplacementApplyOriginalContentFields = void 0;
/**
 * Замена SENDING_REPLACEMENT_APPLY_ORIGINAL_CONTENT_FIELDS в essentials
 */
var ESendingReplacementApplyOriginalContentFields;
(function (ESendingReplacementApplyOriginalContentFields) {
    ESendingReplacementApplyOriginalContentFields["type"] = "type";
    ESendingReplacementApplyOriginalContentFields["payload.sender"] = "payload.sender";
    ESendingReplacementApplyOriginalContentFields["payload.text"] = "payload.text";
    ESendingReplacementApplyOriginalContentFields["fallbacks"] = "fallbacks";
})(ESendingReplacementApplyOriginalContentFields || (exports.ESendingReplacementApplyOriginalContentFields = ESendingReplacementApplyOriginalContentFields = {}));
//# sourceMappingURL=SendingReplacementApplyOriginalContentFields.enum.js.map